<app-main-sidebar></app-main-sidebar>
<app-main-header></app-main-header>
<div class="main-content">
    <router-outlet></router-outlet>
</div>